module.exports = __webpack_public_path__ + "img/steam-engine-V.70179b11.png";